import { Modal } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import { cx } from '../../utils/cx'
import css from '../../styles/EditorV2.module.css'
import classes from './V2Modal.module.css'

/**
 * Dialog chrome of the approved design (Figma "campaign setting overlay", 477:37140): 692px
 * white panel, radius 16, 20px padding and rhythm, 18/600 title, 20px close icon in the
 * corner, black 40% backdrop with an 8px blur, and a footer of 42px buttons under a hairline.
 */
export function V2Modal({ opened, onClose, title, children, footer, size = 692, closeDisabled = false }) {
  const { t } = useTranslation()
  return (
    <Modal
      opened={opened}
      onClose={closeDisabled ? () => {} : onClose}
      title={title}
      size={size}
      radius={16}
      centered
      padding={20}
      closeButtonProps={{ 'aria-label': t('editorV2.shell.close'), disabled: closeDisabled }}
      overlayProps={{ backgroundOpacity: 0.4, blur: 8 }}
      classNames={{
        content: classes.content,
        header: classes.header,
        title: classes.title,
        close: classes.close,
        body: classes.body,
      }}
    >
      <div className={classes.fields}>{children}</div>
      {footer && <div className={classes.footer}>{footer}</div>}
    </Modal>
  )
}

/** Footer button pair: outline Cancel + pink confirm, 42px, 16/500. */
export function V2ModalActions({ onCancel, onConfirm, confirmLabel, cancelLabel, confirmDisabled, busy, confirmType = 'button', form }) {
  const { t } = useTranslation()
  return (
    <>
      <button type="button" className={cx(css.button, classes.footerButton)} onClick={onCancel} disabled={busy}>
        {cancelLabel === undefined ? t('editorV2.shell.cancel') : cancelLabel}
      </button>
      <button
        type={confirmType}
        form={form}
        className={cx(css.button, css.buttonPrimary, classes.footerButton)}
        onClick={confirmType === 'submit' ? undefined : onConfirm}
        disabled={confirmDisabled || busy}
      >
        {confirmLabel}
      </button>
    </>
  )
}
